import React, { useEffect, useState } from "react";
import { markAllOnboardingSkipped, markWelcomeSeen } from "./storageHelper";
import { trackOnboardingEvent } from "./trackEvent";

export default function WelcomeModal({
  onStartTour,
  canStartCatalogTour,
  userId,
  syncReady = true,
  showWelcome = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isSkipping, setIsSkipping] = useState(false);

  // ✅ ממתינים ל-syncReady (סנכרון מהשרת) לפני שמחליטים אם להציג.
  // כך גם אם localStorage ריק (דפדפן אחר), מחכים לתשובת השרת ואם done=true — לא מציגים.
  useEffect(() => {
    if (!userId || !syncReady || !showWelcome) {
      setIsOpen(false);
      return;
    }
    setIsOpen(true);
  }, [userId, syncReady, showWelcome]);

  useEffect(() => {
    if (isOpen) {
      trackOnboardingEvent("welcome_modal_shown");
    }
  }, [isOpen]);

  const markSeen = async () => {
    await markWelcomeSeen(userId);
    setIsOpen(false);
  };

  const handleStartTour = async () => {
    await markSeen();
    trackOnboardingEvent("welcome_modal_start_tour_clicked");
    if (canStartCatalogTour && onStartTour) {
      console.log('[WelcomeModal] Starting catalog tour');
      onStartTour();
    } else {
      console.warn('[WelcomeModal] Cannot start tour:', { canStartCatalogTour, onStartTour });
    }
  };

  const handleSkip = async () => {
    if (isSkipping) return;
    setIsSkipping(true);
    await markAllOnboardingSkipped(userId);
    setIsOpen(false);
    setIsSkipping(false);
    trackOnboardingEvent("welcome_modal_skipped");
  };

  if (!isOpen) return null;

  return (
    <div className="bmc-welcome-modal" dir="rtl" role="presentation">
      <div className="bmc-welcome-modal__backdrop" />
      <section
        className="bmc-welcome-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bmc-welcome-title"
      >
        <div className="bmc-welcome-modal__brand">BMC</div>
        <h2 id="bmc-welcome-title">ברוכים הבאים ל-BMC!</h2>
        <p>
          כאן תוכלו לגלוש בין רכבים, לסנן לפי הצרכים שלכם ולהגיש הצעות
          לספקים. הסיור לוקח פחות מדקה.
        </p>
        <div className="bmc-welcome-modal__actions">
          <button
            type="button"
            className="bmc-welcome-modal__button bmc-welcome-modal__button--primary"
            onClick={handleStartTour}
            disabled={isSkipping}
          >
            ▶ התחל סיור מהיר
          </button>
          <button
            type="button"
            className="bmc-welcome-modal__button bmc-welcome-modal__button--secondary"
            onClick={handleSkip}
            disabled={isSkipping}
          >
            דלג, אסתכל לבד
          </button>
        </div>
      </section>
    </div>
  );
}
